import { Locale } from 'vant';

import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import thTH from 'vant/es/locale/lang/th-TH';
import msMy from '../locales/vant-ms_MY';
import viVN from 'vant/es/locale/lang/th-TH';
import arAE from '../locales/vant-ar_AE';

export function MapLoader() {
    let aMapScript = document.createElement('script')
    aMapScript.setAttribute('src', 'https://webapi.amap.com/maps?v=1.4.15&key=f3c7a3994fa61ddcf4c33b5d6b149c6f')
    document.head.appendChild(aMapScript)
    return aMapScript.onload = function() {
        AMap.plugin('AMap.Geolocation', function() {
            var geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认：true
                enableHighAccuracy: true,
                // 设置定位超时时间，默认：无穷大
                
                // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                buttonOffset: new AMap.Pixel(10, 20),
                //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                zoomToAccuracy: true,
                //  定位按钮的排放位置,  RB表示右下
                buttonPosition: 'RB'
            })
 
            geolocation.getCurrentPosition()
            AMap.event.addListener(geolocation, 'complete', onComplete)
            AMap.event.addListener(geolocation, 'error', onError)
 
            function onComplete(data) {
                // data是具体的定位信息
                console.log(data)
                console.log('123123')
            }
 
            function onError(data) {
                console.log(data)
                    // 定位出错
                console.log('123123s')
            }
        })
    }
}

// i18n缓存
let _i18n;

/**
 * 切换语言
 * @param {'zh-CN' | 'en-US'} lang 语言类型
 */
export const changeLanguage = function(lang, i18n) {
    lang  = lang.replace(/-/g, "_")
    if (i18n) {
        _i18n = i18n
    }

    if (!lang) return

    // vant多语言键值配对
    const keyValue = {
        'en_US': enUS,
        'zh_CN': zhCN,
        'th_TH': thTH,
        'id_ID': msMy,
        'ms_MY': msMy,
        'vi_VN': viVN,
        'ar_AE': arAE
    }

    if (!keyValue[lang]) {
        console.error('多语言切换失败', lang);
    }
    console.log(keyValue[lang],`keyValue[lang]`)
    // 切换vant多语言
    Locale.use(lang, keyValue[lang])

    _i18n.locale = lang

    localStorage.setItem('language', lang)
}


// WEBPACK FOOTER //
// src/util/locationutil.js